module.exports = __webpack_public_path__ + "img/bottom1.360deadc.png";